module.exports = __webpack_public_path__ + "img/circle-arrow-up.610d232e.svg";